import React from 'react';

const Logo = () => (
  <div style={{ display: 'flex', alignItems: 'center', marginRight: '12px' }}>
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ transform: 'scale(1.1)', transition: 'transform 0.2s' }}>
      {/* Google Blue Background Circle with Rounded Corners feel */}
      <rect width="40" height="40" rx="10" fill="#4285F4" shadow-sm="true"/>
      
      {/* Stylized White Chicken/Broiler Silhouette */}
      <path 
        d="M28 24C28 27.3137 25.3137 30 22 30H14C10.6863 30 8 27.3137 8 24V20C8 16.6863 10.6863 14 14 14H16L18 10L20 14H22C25.3137 14 28 16.6863 28 20V24Z" 
        fill="white"
      />
      
      {/* Eye */}
      <circle cx="23" cy="19" r="1.5" fill="#4285F4"/>
      
      {/* Beak - Google Yellow */}
      <path d="M28 20L32 22L28 24V20Z" fill="#FBBC05"/>
      
      {/* Comb - Google Red */}
      <path d="M16 10C16 8.34315 17.3431 7 19 7C20.6569 7 22 8.34315 22 10H16Z" fill="#EA4335"/>
    </svg>
  </div>
);

export default Logo;
